/* Utilidad compartida para formatear atributos */
function formatCartAttributes(propsObj) {
  return Object.entries(propsObj)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => ({ key: key, value: String(value) }));
}

/* ====================================================================================== */
/* Create cart notification */
/* ====================================================================================== */
function addMiniCartNotification(product_id_numeric, free_product, parentProductQuantity) {
  const cart = window.CartAPI.cartData;
  const product_gid = `gid://shopify/ProductVariant/${product_id_numeric}`;
  console.log("Cart data for notification:", cart); // Debug: Verificar estructura del carrito
  console.log("Looking for product GID in cart:", product_gid); // Debug: Verificar el GID que buscamos

  if (!cart) return;

  if (parentProductQuantity != 0) {
    $("[js-cart-notification]").addClass("active");
    $(".js-cart-items-notification").empty();
    
    const items = cart.lines.edges.map(edge => edge.node);
    
    var index = items.findIndex(item => item.merchandise.id === product_gid);

    if (index != -1) {
      const currentItem = items[index];
      
      let prodQty = parentProductQuantity || 1;
      
      const props = currentItem.attributes.reduce((acc, attr) => {
        acc[attr.key] = attr.value;
        return acc;
      }, {});

      const cart_title = currentItem.merchandise.product.title
      const cart_price = parseFloat(currentItem.merchandise.price.amount) / currentItem.quantity
      const cart_subtotal = parseFloat(currentItem.merchandise.price.amount)
      const cart_image = `url('${currentItem.merchandise.image?.url || ''}')`
      const cart_iQuantity = currentItem.quantity
      const cart_PropertiesCompare = currentItem.merchandise.compareAtPrice ? parseFloat(currentItem.merchandise.compareAtPrice.amount) : ""
      const cart_PropertiesTag = props["productTagDiscount"] || ""

      $("[data-product-title-popup]").empty().append(cart_title);
      $("[data-product-price-popup]").empty().append(
        new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(cart_price)
      );
      $("[data-product-subtotal-popup]").empty().append(
        new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(cart_subtotal)
      );
      
      if(currentItem.merchandise.image) {
        $("[data-product-image-popup]").empty().append(
          '<span class="c-cart-notification__product-image" style="background: ' + cart_image + ' no-repeat center center; background-size: cover;"></span>'
        );
      }

      $("[data-cart-count-bubble]").removeClass("d-none");
      $("[data-cart-count]").text(cart.totalQuantity);

      if (cart_PropertiesCompare) {
        $("[data-product-compare-popup]").empty().append(
          new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(cart_PropertiesCompare)
        );
      }

      if (cart_PropertiesTag != "") {
        $(".c-cart-notification__product-price-tag").removeClass("d-none");
        $("[data-product-tag-popup]").empty().append(cart_PropertiesTag);
      } else {
        $(".c-cart-notification__product-price-tag").addClass("d-none");
      }

      $("[js-cart-notification]").attr("data-line-id", currentItem.id); 
      $("[js-cart-notification]").attr("data-product-id", product_id_numeric);
      $(".js-quantity-input").val(prodQty || 1);

      if (free_product && free_product.length > 0) {
        $("[js-cart-notification-free-product]").addClass("active");
        $("[js-cart-notification-free-product]").attr("data-has-promo", free_product);
      } else {
        $("[js-cart-notification-free-product]").removeClass("active");
        $("[js-cart-notification-free-product]").attr("data-has-promo", "");
      }

      var timeout = setTimeout(function () { $("[js-cart-notification]").removeClass("active"); }, 3000);
      $("[js-cart-notification]").off('hover').hover(
        function () { clearTimeout(timeout); },
        function () { timeout = setTimeout(function () { $("[js-cart-notification]").removeClass("active"); }, 3000); }
      );
      $("[js-cart-notification]").off('mousemove').mousemove(function (event) { clearTimeout(timeout); });
    }
  } else {
    $("[js-cart-notification]").removeClass("active");
    $("[data-cart-count]").text(cart.totalQuantity);
  }
}

/* ====================================================================================== */
/* Update cart */
/* ====================================================================================== */
async function updateCartNotification(iQuantity, line_id_gql, product_id_numeric, promoProducts) {
  try {
    // Usamos el ID de línea para actualizar usando nuestra librería (debes agregar updateLines a StorefrontCart.js)
    await window.CartAPI.updateLines([{
      id: line_id_gql,
      quantity: iQuantity
    }]);

    // Actualizamos los productos de regalo
    await updateFreeProductQuantities(product_id_numeric, promoProducts, iQuantity);
    
    // Renderizamos de nuevo
    addMiniCartNotification(product_id_numeric, promoProducts, iQuantity);
  } catch (error) {
    console.error("Error updating cart:", error);
  }
}

/* ====================================================================================== */
/* Update quantity of free products */
/* ====================================================================================== */
async function updateFreeProductQuantities(parentProductID_numeric, promos, quantity) {
  if (!promos) return;
  
  let promoProds = promos.split(",");
  const cart = window.CartAPI.cartData;
  const items = cart.lines.edges.map(edge => edge.node);
  
  let linesToUpdate = [];

  promoProds.forEach((idProductFree_numeric) => {
    const free_gid = `gid://shopify/ProductVariant/${idProductFree_numeric}`;
    
    // Buscamos la línea que es de regalo Y pertenece a este producto padre
    let cartItem = items.find(item => {
      const isCorrectVariant = item.merchandise.id === free_gid;
      const hasParentAttr = item.attributes.some(attr => attr.key === "productFree" && attr.value === String(parentProductID_numeric));
      return isCorrectVariant && hasParentAttr;
    });

    if (cartItem) {
      linesToUpdate.push({
        id: cartItem.id, // El CartLine ID
        quantity: quantity
      });
    }
  });

  if (linesToUpdate.length > 0) {
    await window.CartAPI.updateLines(linesToUpdate);
  }
}

/* ====================================================================================== */
/* DOMContentLoaded Events */
/* ====================================================================================== */
document.addEventListener("DOMContentLoaded", () => {
  
  /* Add to cart - Product (Desde tarjetas js-add-cart-notification) */
  $("body").on("click", ".js-add-cart-notification", async function (event) {
    event.preventDefault();
    event.stopPropagation();
    
    var el = $(this),
      product_id = parseFloat(el.attr("data-product-variant-id")),
      product_quantity = parseFloat(el.attr("data-product-quantity")),
      productType = el.attr("data-product-properties"),
      productCompare = el.attr("data-product-compare"),
      productTagDiscount = el.attr("data-product-tag"),
      productPickup = el.attr("data-pickup"),
      productCategory = el.attr("data-product-category");
      pickupStoreId = el.attr("data-pickup-store-id"),
      productUrl = el.attr("data-product-url"),
      productIsOutlet = el.attr("data-is-outlet"),
      productBarcode = el.attr("data-variant-barcode"),
      productVariant = el.attr("data-selected-original-variant")
      promoProducts = el.attr("data-has-promo"); 

    // UI: Loaders
    el.closest("[js-product-card-grid]").find("[data-loader]").removeClass("d-none");
    el.closest("[js-product-card-grid]").find("[data-add-to-cart-text]").addClass("d-none");
    el.closest("#quickviewProduct").find("[data-loader]").removeClass("d-none");
    el.closest("#quickviewProduct").find("[data-add-to-cart-text]").addClass("d-none");

    try {
      let linesToAdd = [];

      // 1. Producto Padre
      linesToAdd.push({
        merchandiseId: `gid://shopify/ProductVariant/${product_id}`,
        quantity: product_quantity,
        productUrl: productUrl,
        attributes: formatCartAttributes({
          productType, 
          productCompare, 
          productTagDiscount, 
          productPickup, 
          pickupStoreId, 
          promoProducts,
          _outlet_product: productIsOutlet,
          _barcode: productBarcode,
          _category: productCategory,
          _selected_outlet_variant: productVariant
        })
      });

      // 2. Productos Regalo (Empaquetados en la misma petición)
      if (promoProducts && promoProducts !== "") {
        var itemsPromo = el.closest("[js-product-card-grid]").find("[js-product-grid-promo-item]");
        if (itemsPromo.length === 0) { itemsPromo = promoProducts.split(","); }

        for (let i = 0; i < itemsPromo.length; i++) {
          let promo_product_id, prodCompareFree, prodTagFree;
          
          if (typeof itemsPromo[0] === "string") {
            promo_product_id = parseFloat(itemsPromo[i]);
          } else {
            let element = $(itemsPromo[i]);
            promo_product_id = parseFloat(element.attr("data-product-variant-id"));
            prodCompareFree = element.attr("data-product-compare");
            prodTagFree = element.attr("data-product-tag");
          }

          linesToAdd.push({
            merchandiseId: `gid://shopify/ProductVariant/${promo_product_id}`,
            quantity: product_quantity,
            attributes: formatCartAttributes({
              productType, productCompare: prodCompareFree, productTagDiscount: prodTagFree, 
              productPickup, pickupStoreId, productFree: product_id
            })
          });
        }
      }

      // 3. Ejecutar Petición Única GQL con validación de stock
      await window.CartAPI.addOrUpdateItems(linesToAdd);

      // UI: Éxito
      addMiniCartNotification(product_id, promoProducts, product_quantity);
      el.closest("[js-product-card-grid]").find(".js-product-message").addClass("d-none");
      el.closest("#quickviewProduct").find(".js-error-message-content").addClass("d-none");
      el.closest("#quickviewProduct").removeClass("active");
      
    } catch (error) {
      // UI: Error
      el.closest("[js-product-card-grid]").find(".js-product-message").removeClass("d-none");
      el.closest("[js-product-card-grid]").find("[text-message-warning]").empty().append(error.message);
      el.closest("#quickviewProduct").find(".js-error-message-content").removeClass("d-none");
      el.closest("#quickviewProduct").find("[text-message-warning]").empty().append(error.message);
    } finally {
      // UI: Complete
      el.closest("[js-product-card-grid]").find("[data-loader]").addClass("d-none");
      el.closest("[js-product-card-grid]").find("[data-add-to-cart-text]").removeClass("d-none");
      el.closest("#quickviewProduct").find("[data-loader]").addClass("d-none");
      el.closest("#quickviewProduct").find("[data-add-to-cart-text]").removeClass("d-none");
      document.querySelector("body").style.overflow = "auto";
    }
  });

  /* Close - Minicart Popup (Se mantiene igual, pura UI) */
  $("[js-cart-notification]").on("click", ".js-close-data", function (event) {
    event.preventDefault();
    var el = $(this), item = $(el.attr("data-close"));
    el.removeClass("active"); item.removeClass("active"); item.removeAttr("open");
  });
  
  $("[js-cart-notification]").on("click", ".js-continue", function (event) {
    event.preventDefault();
    let close = document.querySelector('[data-close=".c-cart-notification"]');
    close.click();
  });

  /* Quantity Product - Minicart Popup */
  $("[js-cart-notification]").on("click", "[name=minus], [name=plus]", function (event) {
    event.preventDefault();
    var spinner = $(this),
      isMinus = spinner.attr("name") === "minus",
      input = spinner.closest(".js-notification-quantity").find('input[type="number"]'),
      min = input.attr("min") ? parseFloat(input.attr("min")) : 0,
      max = input.attr("max") ? parseFloat(input.attr("max")) : 999,
      oldValue = parseFloat(input.val()),
      // AHORA LEEMOS EL data-line-id QUE GUARDAMOS
      line_id_gql = spinner.closest("[js-cart-notification]").attr("data-line-id"), 
      product_id_numeric = parseFloat(spinner.closest("[js-cart-notification]").attr("data-product-id")),
      promoProducts = $("[js-cart-notification]").find("[js-cart-notification-free-product]").attr("data-has-promo");
    
    var newVal = isMinus ? (oldValue <= min ? oldValue : oldValue - 1) : (oldValue >= max ? oldValue : oldValue + 1);
    
    if(newVal !== oldValue) {
      input.val(newVal);
      updateCartNotification(newVal, line_id_gql, product_id_numeric, promoProducts);
    }
  });

  $("[js-cart-notification]").on("keyup", ".js-quantity-input", debounce(function () {
    var input = $(this),
      inputValue = parseFloat(input.val()),
      line_id_gql = input.closest("[js-cart-notification]").attr("data-line-id"),
      product_id_numeric = parseFloat(input.closest("[js-cart-notification]").attr("data-product-id")),
      promoProducts = $("[js-cart-notification]").find("[js-cart-notification-free-product]").attr("data-has-promo");
    
    if(!isNaN(inputValue)) {
      updateCartNotification(inputValue, line_id_gql, product_id_numeric, promoProducts);
    }
  }, 500));
});

// Helper debounce si no estaba definido
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => { clearTimeout(timeout); func(...args); };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}